// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login-page.animated-bg {
  animation: gradientShift 15s ease infinite;
  background-size: 400% 400%;
}
[data-coreui-theme=dark] .login-page {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
}

.animated-shapes {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
  overflow: hidden;
  z-index: 1;
}
.animated-shapes .shape {
  position: absolute;
  border-radius: 50%;
  filter: blur(40px);
  animation: float 20s infinite ease-in-out;
}
.animated-shapes .shape.shape-1 {
  width: 500px;
  height: 500px;
  background: rgba(243, 147, 251, 0.3);
  top: -250px;
  right: -250px;
  animation-delay: 0s;
  animation-duration: 25s;
}
.animated-shapes .shape.shape-2 {
  width: 400px;
  height: 400px;
  background: rgba(245, 87, 108, 0.3);
  bottom: -200px;
  left: -200px;
  animation-delay: 5s;
  animation-duration: 20s;
}
.animated-shapes .shape.shape-3 {
  width: 300px;
  height: 300px;
  background: rgba(102, 126, 234, 0.3);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation-delay: 10s;
  animation-duration: 30s;
}
.animated-shapes .floating-gradient {
  position: absolute;
  width: 150%;
  height: 150%;
  background: radial-gradient(circle at 50% 50%, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 50%, transparent 100%);
  animation: rotate 60s linear infinite;
  top: -25%;
  left: -25%;
}

.login-container {
  width: 100%;
  max-width: 1400px;
  padding: 2rem;
}
@media (max-width: 768px) {
  .login-container {
    padding: 1rem;
  }
}

.login-wrapper {
  position: relative;
  z-index: 10;
  animation: slideInUp 0.8s ease-out;
  width: 100%;
}
.login-wrapper .login-card {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  border-radius: 30px;
  min-height: 650px;
  height: auto;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
[data-coreui-theme=dark] .login-wrapper .login-card {
  background: rgba(33, 37, 41, 0.98);
}
.login-wrapper .login-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.25);
}
.login-wrapper .login-card.shake {
  animation: shake 0.5s ease;
}

.login-form-section {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 650px;
}
@media (max-width: 991px) {
  .login-form-section {
    min-height: 500px;
  }
}
.login-form-section .login-form-body {
  width: 100%;
  padding: 3rem;
}
@media (max-width: 991px) {
  .login-form-section .login-form-body {
    padding: 2.5rem;
  }
}
@media (max-width: 576px) {
  .login-form-section .login-form-body {
    padding: 2rem 1.5rem;
  }
}
.login-form-section .login-content {
  max-width: 420px;
  margin: 0 auto;
  width: 100%;
}
.login-form-section .login-header {
  text-align: center;
  animation: fadeIn 1s ease-out 0.3s both;
}
.login-form-section .login-header .logo-wrapper {
  display: inline-block;
  position: relative;
}
.login-form-section .login-header .logo-wrapper .logo-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 15px 35px rgba(102, 126, 234, 0.3);
  position: relative;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.login-form-section .login-header .logo-wrapper .logo-icon::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transform: rotate(45deg);
  animation: shimmer 3s infinite;
}
.login-form-section .login-header .logo-wrapper .logo-icon:hover {
  transform: scale(1.1) rotate(5deg);
  box-shadow: 0 20px 45px rgba(102, 126, 234, 0.4);
}
@media (max-width: 576px) {
  .login-form-section .login-header .logo-wrapper .logo-icon {
    width: 70px;
    height: 70px;
  }
}
.login-form-section .login-header .login-title {
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
[data-coreui-theme=dark] .login-form-section .login-header .login-title {
  background: linear-gradient(135deg, #8da3f0 0%, #b88fe8 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
@media (max-width: 576px) {
  .login-form-section .login-header .login-title {
    font-size: 1.75rem;
  }
}
.login-form-section .login-header .login-subtitle {
  font-size: 1rem;
  color: #6c757d;
}
[data-coreui-theme=dark] .login-form-section .login-header .login-subtitle {
  color: #adb5bd;
}
.login-form-section .login-form {
  animation: fadeIn 1s ease-out 0.5s both;
}

.form-floating-group {
  position: relative;
  margin-bottom: 1.5rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.form-floating-group.focused {
  transform: translateY(-2px);
}
.form-floating-group .modern-input-group {
  position: relative;
  background: #f8f9fa;
  border-radius: 15px;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent;
}
[data-coreui-theme=dark] .form-floating-group .modern-input-group {
  background: rgba(255, 255, 255, 0.05);
}
.form-floating-group .modern-input-group:focus-within {
  background: white;
  border-color: #667eea;
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.1);
}
[data-coreui-theme=dark] .form-floating-group .modern-input-group:focus-within {
  background: rgba(255, 255, 255, 0.08);
}
.form-floating-group .modern-input-group:focus-within .input-icon {
  color: #667eea;
  transform: scale(1.1);
}
.form-floating-group .modern-input-group:focus-within .input-focus-border {
  transform: scaleX(1);
}
.form-floating-group .modern-input-group .input-icon {
  background: transparent;
  border: none;
  color: #6c757d;
  padding: 0 1.25rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
[data-coreui-theme=dark] .form-floating-group .modern-input-group .input-icon {
  color: #adb5bd;
}
.form-floating-group .modern-input-group .modern-input {
  border: none;
  background: transparent;
  padding: 1rem 0;
  font-size: 1rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.form-floating-group .modern-input-group .modern-input:focus {
  box-shadow: none;
  outline: none;
}
.form-floating-group .modern-input-group .modern-input::placeholder {
  color: #adb5bd;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.form-floating-group .modern-input-group .modern-input:focus::placeholder {
  transform: translateX(5px);
  opacity: 0.7;
}
.form-floating-group .modern-input-group .modern-input.is-invalid {
  background: rgba(245, 87, 108, 0.05);
}
.form-floating-group .modern-input-group .password-toggle {
  background: transparent;
  border: none;
  cursor: pointer;
  color: #6c757d;
  padding: 0 1.25rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
[data-coreui-theme=dark] .form-floating-group .modern-input-group .password-toggle {
  color: #adb5bd;
}
.form-floating-group .modern-input-group .password-toggle:hover {
  color: #667eea;
  background: rgba(102, 126, 234, 0.05);
}
.form-floating-group .modern-input-group .input-focus-border {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}
.form-floating-group .animated-error {
  animation: slideInLeft 0.3s ease;
  color: #f5576c;
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  font-weight: 500;
}

.modern-checkbox .form-check-input {
  width: 1.25rem;
  height: 1.25rem;
  border: 2px solid #dee2e6;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.modern-checkbox .form-check-input:checked {
  background-color: #667eea;
  border-color: #667eea;
  box-shadow: 0 3px 10px rgba(102, 126, 234, 0.3);
}
.modern-checkbox .form-check-input:focus {
  box-shadow: 0 0 0 0.25rem rgba(102, 126, 234, 0.25);
}
.modern-checkbox .form-check-label {
  margin-left: 0.5rem;
  color: #6c757d;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
[data-coreui-theme=dark] .modern-checkbox .form-check-label {
  color: #adb5bd;
}
.modern-checkbox .form-check-label:hover {
  color: #667eea;
}

.forgot-password-link {
  color: #667eea;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}
.forgot-password-link::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  transition: width 0.3s ease;
}
.forgot-password-link:hover {
  color: #764ba2;
}
.forgot-password-link:hover::after {
  width: 100%;
}

.login-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 15px;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  font-weight: 600;
  color: white;
  position: relative;
  overflow: hidden;
  transition: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
}
.login-button::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s ease;
}
.login-button:hover:not(:disabled) {
  transform: translateY(-3px);
  box-shadow: 0 15px 40px rgba(102, 126, 234, 0.4);
}
.login-button:hover:not(:disabled)::before {
  left: 100%;
}
.login-button:active:not(:disabled) {
  transform: translateY(-1px);
}
.login-button:disabled {
  background: #6c757d;
  opacity: 0.7;
  cursor: not-allowed;
}
.login-button .spinner-border {
  width: 1rem;
  height: 1rem;
  border-width: 2px;
}

.divider-container {
  display: flex;
  align-items: center;
  margin: 2rem 0;
}
.divider-container .divider-line {
  flex: 1 1;
  height: 1px;
  background: linear-gradient(90deg, transparent, #dee2e6, transparent);
}
.divider-container .divider-text {
  padding: 0 1rem;
  color: #6c757d;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 500;
}
[data-coreui-theme=dark] .divider-container .divider-text {
  color: #adb5bd;
}

.social-login-btn {
  border: 2px solid #e9ecef;
  border-radius: 12px;
  padding: 0.75rem;
  background: white;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 600;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
[data-coreui-theme=dark] .social-login-btn {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.1);
  color: #e9ecef;
}
.social-login-btn .social-icon {
  width: 20px;
  height: 20px;
  margin-right: 0.5rem;
}
.social-login-btn.google-btn:hover {
  border-color: #4285F4;
  background: rgba(66, 133, 244, 0.05);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(66, 133, 244, 0.2);
}
.social-login-btn.microsoft-btn:hover {
  border-color: #00A4EF;
  background: rgba(0, 164, 239, 0.05);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 164, 239, 0.2);
}

.welcome-section {
  position: relative;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  overflow: hidden;
  min-height: 650px;
}
@media (max-width: 1200px) {
  .welcome-section {
    padding: 2.5rem 1.5rem;
  }
}
@media (max-width: 991px) {
  .welcome-section {
    display: none !important;
  }
}
.welcome-section .welcome-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 30% 80%, rgba(243, 147, 251, 0.3) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(245, 87, 108, 0.3) 0%, transparent 50%);
  animation: pulse 4s ease-in-out infinite;
}
.welcome-section .welcome-content {
  position: relative;
  height: 100%;
  z-index: 2;
  color: white;
  text-align: center;
}
.welcome-section .welcome-text {
  animation: fadeInUp 1s ease-out 0.7s both;
}
.welcome-section .welcome-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  text-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
  line-height: 1.3;
}
.welcome-section .welcome-description {
  font-size: 1.1rem;
  margin-bottom: 3rem;
  opacity: 0.95;
  line-height: 1.6;
}
.welcome-section .feature-list {
  display: flex;
  flex-direction: column;
  align-items: start;
  max-width: 300px;
  margin: 0 auto;
}
.welcome-section .feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  width: 100%;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.welcome-section .feature-item:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateX(10px);
}
.welcome-section .feature-item .feature-icon {
  color: #43e97b;
  margin-right: 1rem;
  font-size: 1.25rem;
  filter: drop-shadow(0 2px 5px rgba(67, 233, 123, 0.5));
}
.welcome-section .feature-item span {
  font-size: 1rem;
  font-weight: 500;
}
.welcome-section .decoration-circles {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
}
.welcome-section .decoration-circles .circle {
  position: absolute;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.2);
  animation: float 15s infinite ease-in-out;
}
.welcome-section .decoration-circles .circle.circle-1 {
  width: 100px;
  height: 100px;
  top: 10%;
  right: 10%;
  animation-delay: 0s;
}
.welcome-section .decoration-circles .circle.circle-2 {
  width: 150px;
  height: 150px;
  bottom: 20%;
  left: 5%;
  animation-delay: 5s;
}
.welcome-section .decoration-circles .circle.circle-3 {
  width: 80px;
  height: 80px;
  top: 50%;
  right: 30%;
  animation-delay: 10s;
}

.two-factor-modal .modal-content {
  border: none;
  border-radius: 25px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}
[data-coreui-theme=dark] .two-factor-modal .modal-content {
  background: rgba(33, 37, 41, 0.98);
}
.two-factor-modal .two-factor-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 2rem;
  border: none;
}
.two-factor-modal .two-factor-header .modal-title {
  font-weight: 600;
  display: flex;
  align-items: center;
}
.two-factor-modal .two-factor-header .btn-close {
  filter: brightness(0) invert(1);
  opacity: 0.8;
}
.two-factor-modal .two-factor-header .btn-close:hover {
  opacity: 1;
}
.two-factor-modal .two-factor-body {
  padding: 2.5rem 2rem;
}
.two-factor-modal .two-factor-body .security-icon-wrapper {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 15px 35px rgba(67, 233, 123, 0.3);
  animation: pulse 2s ease-in-out infinite;
}
.two-factor-modal .two-factor-body .security-icon-wrapper .security-icon {
  color: white;
  filter: drop-shadow(0 3px 8px rgba(0, 0, 0, 0.2));
}
.two-factor-modal .two-factor-body .security-message {
  color: #6c757d;
  font-size: 1rem;
  line-height: 1.5;
}
[data-coreui-theme=dark] .two-factor-modal .two-factor-body .security-message {
  color: #adb5bd;
}
.two-factor-modal .two-factor-body .two-factor-input {
  border: 2px solid #e9ecef;
  border-radius: 15px;
  padding: 1rem;
  font-size: 1.5rem;
  text-align: center;
  letter-spacing: 5px;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
[data-coreui-theme=dark] .two-factor-modal .two-factor-body .two-factor-input {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.1);
  color: #e9ecef;
}
.two-factor-modal .two-factor-body .two-factor-input:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 0.25rem rgba(102, 126, 234, 0.25);
}
.two-factor-modal .two-factor-body .resend-link {
  color: #667eea;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.two-factor-modal .two-factor-body .resend-link:hover {
  color: #764ba2;
  text-decoration: underline;
}
.two-factor-modal .two-factor-footer {
  padding: 1.5rem 2rem 2rem;
  border: none;
}
.two-factor-modal .two-factor-footer .cancel-btn {
  border-radius: 12px;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
}
.two-factor-modal .two-factor-footer .verify-btn {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
  border: none;
  border-radius: 12px;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.two-factor-modal .two-factor-footer .verify-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(67, 233, 123, 0.3);
}
.two-factor-modal .two-factor-footer .verify-btn:disabled {
  background: #6c757d;
  opacity: 0.7;
}

@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@keyframes float {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  33% {
    transform: translateY(-30px) rotate(120deg);
  }
  66% {
    transform: translateY(20px) rotate(240deg);
  }
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes slideInUp {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeInUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
@keyframes slideInLeft {
  from {
    transform: translateX(-20px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes shimmer {
  0% {
    transform: translateX(-100%) rotate(45deg);
  }
  100% {
    transform: translateX(100%) rotate(45deg);
  }
}
@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
}
@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: translateX(-5px);
  }
  20%, 40%, 60%, 80% {
    transform: translateX(5px);
  }
}
@media (max-width: 991px) {
  .login-wrapper .login-card {
    min-height: auto;
  }
  .welcome-section {
    display: none !important;
  }
  .login-form-section {
    padding: 2.5rem;
  }
}
@media (max-width: 576px) {
  .login-form-section {
    padding: 2rem 1.5rem;
  }
  .login-form-section .login-header .login-title {
    font-size: 1.75rem;
  }
  .login-form-section .login-header .logo-wrapper .logo-icon {
    width: 70px;
    height: 70px;
  }
  .login-button {
    font-size: 1rem;
    padding: 0.875rem 1.5rem;
  }
  .social-login-btn {
    font-size: 0.85rem;
    padding: 0.625rem;
  }
  .two-factor-modal .two-factor-body {
    padding: 2rem 1.5rem;
  }
}
[data-coreui-theme=dark] .login-page .animated-shapes .shape {
  opacity: 0.5;
}
[data-coreui-theme=dark] .login-wrapper .login-card {
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.shadow-lg {
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
}

.border-0 {
  border: none !important;
}

.overflow-hidden {
  overflow: hidden !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Login/Login.scss"],"names":[],"mappings":"AAkBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,6DAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjBF;AAmBE;EACE,0CAAA;EACA,0BAAA;AAjBJ;AAqBE;EACE,6DAAA;AAnBJ;;AAwBA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,oBAAA;EACA,gBAAA;EACA,UAAA;AArBF;AAuBE;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yCAAA;AArBJ;AAuBI;EACE,YAAA;EACA,aAAA;EACA,oCAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AArBN;AAwBI;EACE,YAAA;EACA,aAAA;EACA,mCAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AAtBN;AAyBI;EACE,YAAA;EACA,aAAA;EACA,oCAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,oBAAA;EACA,uBAAA;AAvBN;AA2BE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,0HAAA;EAIA,qCAAA;EACA,SAAA;EACA,UAAA;AA5BJ;;AAiCA;EACE,WAAA;EACA,iBAAA;EACA,aAAA;AA9BF;AAgCE;EALF;IAMI,aAAA;EA7BF;AACF;;AAiCA;EACE,kBAAA;EACA,WAAA;EACA,kCAAA;EACA,WAAA;AA9BF;AAgCE;EACE,qCAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,iDAlHc;AAoFlB;AAgCI;EACE,kCAAA;AA9BN;AAiCI;EACE,2BAAA;EACA,2CAAA;AA/BN;AAkCI;EACE,0BAAA;AAhCN;;AAsCA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AAnCF;AAqCE;EANF;IAOI,iBAAA;EAlCF;AACF;AAoCE;EACE,WAAA;EACA,aAAA;AAlCJ;AAoCI;EAJF;IAKI,eAAA;EAjCJ;AACF;AAmCI;EARF;IASI,oBAAA;EAhCJ;AACF;AAmCE;EACE,gBAAA;EACA,cAAA;EACA,WAAA;AAjCJ;AAoCE;EACE,kBAAA;EACA,uCAAA;AAlCJ;AAoCI;EACE,qBAAA;EACA,kBAAA;AAlCN;AAoCM;EACE,WAAA;EACA,YAAA;EACA,6DAvLW;EAwLX,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,gDAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDArLU;AAmJlB;AAoCQ;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EAIA,wBAAA;EACA,8BAAA;AArCV;AAwCQ;EACE,kCAAA;EACA,gDAAA;AAtCV;AAyCQ;EAlCF;IAmCI,WAAA;IACA,YAAA;EAtCR;AACF;AA0CI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,6DAlOa;EAmOb,6BAAA;EACA,oCAAA;EACA,qBAAA;AAxCN;AA0CM;EACE,6DAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;AAxCR;AA2CM;EAjBF;IAkBI,kBAAA;EAxCN;AACF;AA2CI;EACE,eAAA;EACA,cAAA;AAzCN;AA2CM;EACE,cAAA;AAzCR;AA8CE;EACE,uCAAA;AA5CJ;;AAiDA;EACE,kBAAA;EACA,qBAAA;EACA,iDA3PgB;AA6MlB;AAgDE;EACE,2BAAA;AA9CJ;AAiDE;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iDAtQc;EAuQd,6BAAA;AA/CJ;AAiDI;EACE,qCAAA;AA/CN;AAkDI;EACE,iBAAA;EACA,qBArRU;EAsRV,gDAAA;AAhDN;AAkDM;EACE,qCAAA;AAhDR;AAmDM;EACE,cA7RQ;EA8RR,qBAAA;AAjDR;AAoDM;EACE,oBAAA;AAlDR;AAsDI;EACE,uBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,iDArSY;AAiPlB;AAsDM;EACE,cAAA;AApDR;AAwDI;EACE,YAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,iDAjTY;AA2PlB;AAwDM;EACE,gBAAA;EACA,aAAA;AAtDR;AAyDM;EACE,cAAA;EACA,iDA1TU;AAmQlB;AA0DM;EACE,0BAAA;EACA,YAAA;AAxDR;AA2DM;EACE,oCAAA;AAzDR;AA6DI;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,iDA7UY;AAkRlB;AA6DM;EACE,cAAA;AA3DR;AA8DM;EACE,cA1VQ;EA2VR,qCAAA;AA5DR;AAgEI;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,6DA1Wa;EA2Wb,oBAAA;EACA,+BAAA;AA9DN;AAkEE;EACE,gCAAA;EACA,cA1WU;EA2WV,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAhEJ;;AAsEE;EACE,cAAA;EACA,eAAA;EACA,yBAAA;EACA,iDArXc;AAkTlB;AAqEI;EACE,yBA9XU;EA+XV,qBA/XU;EAgYV,+CAAA;AAnEN;AAsEI;EACE,mDAAA;AApEN;AAwEE;EACE,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,iDAvYc;AAiUlB;AAwEI;EACE,cAAA;AAtEN;AAyEI;EACE,cApZU;AA6UhB;;AA6EA;EACE,cA3Zc;EA4Zd,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iDAzZgB;EA0ZhB,kBAAA;AA1EF;AA4EE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,6DA9ae;EA+af,2BAAA;AA1EJ;AA6EE;EACE,cA7ac;AAkWlB;AA6EI;EACE,WAAA;AA3EN;;AAiFA;EACE,6DA7biB;EA8bjB,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,yDA1bkB;EA2blB,yBAAA;EACA,mBAAA;EACA,gDAAA;AA9EF;AAgFE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EAIA,0BAAA;AAjFJ;AAoFE;EACE,2BAAA;EACA,gDAAA;AAlFJ;AAoFI;EACE,UAAA;AAlFN;AAsFE;EACE,2BAAA;AApFJ;AAuFE;EACE,mBAAA;EACA,YAAA;EACA,mBAAA;AArFJ;AAwFE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAtFJ;;AA2FA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;AAxFF;AA0FE;EACE,SAAA;EACA,WAAA;EACA,qEAAA;AAxFJ;AA2FE;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAzFJ;AA2FI;EACE,cAAA;AAzFN;;AA+FA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iDAxgBgB;EAygBhB,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA5FF;AA8FE;EACE,qCAAA;EACA,sCAAA;EACA,cAAA;AA5FJ;AA+FE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;AA7FJ;AAgGE;EACE,qBAAA;EACA,oCAAA;EACA,2BAAA;EACA,8CAAA;AA9FJ;AAiGE;EACE,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,6CAAA;AA/FJ;;AAoGA;EACE,kBAAA;EACA,6DAxjBiB;EAyjBjB,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAjGF;AAmGE;EAVF;IAWI,sBAAA;EAhGF;AACF;AAkGE;EAdF;IAeI,wBAAA;EA/FF;AACF;AAiGE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,6KAAA;EAMA,wCAAA;AApGJ;AAuGE;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;AArGJ;AAwGE;EACE,yCAAA;AAtGJ;AAyGE;EACE,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,0CAAA;EACA,gBAAA;AAvGJ;AA0GE;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AAxGJ;AA2GE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAzGJ;AA4GE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;EACA,oCAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;EACA,iDAxnBc;AA8gBlB;AA4GI;EACE,oCAAA;EACA,2BAAA;AA1GN;AA6GI;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,sDAAA;AA3GN;AA8GI;EACE,eAAA;EACA,gBAAA;AA5GN;AAgHE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,oBAAA;AA9GJ;AAgHI;EACE,kBAAA;EACA,kBAAA;EACA,0CAAA;EACA,yCAAA;AA9GN;AAgHM;EACE,YAAA;EACA,aAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;AA9GR;AAiHM;EACE,YAAA;EACA,aAAA;EACA,WAAA;EACA,QAAA;EACA,mBAAA;AA/GR;AAkHM;EACE,WAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;EACA,oBAAA;AAhHR;;AAwHE;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;AArHJ;AAuHI;EACE,kCAAA;AArHN;AAyHE;EACE,6DA9sBe;EA+sBf,YAAA;EACA,aAAA;EACA,YAAA;AAvHJ;AAyHI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAvHN;AA0HI;EACE,+BAAA;EACA,YAAA;AAxHN;AA0HM;EACE,UAAA;AAxHR;AA6HE;EACE,oBAAA;AA3HJ;AA6HI;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,6DAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+CAAA;EACA,wCAAA;AA3HN;AA6HM;EACE,YAAA;EACA,iDAAA;AA3HR;AA+HI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AA7HN;AA+HM;EACE,cAAA;AA7HR;AAiII;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iDA/vBY;AAgoBlB;AAiIM;EACE,qCAAA;EACA,sCAAA;EACA,cAAA;AA/HR;AAkIM;EACE,qBA9wBQ;EA+wBR,mDAAA;AAhIR;AAoII;EACE,cApxBU;EAqxBV,qBAAA;EACA,gBAAA;EACA,iDAjxBY;AA+oBlB;AAoIM;EACE,cAzxBU;EA0xBV,0BAAA;AAlIR;AAuIE;EACE,yBAAA;EACA,YAAA;AArIJ;AAuII;EACE,mBAAA;EACA,uBAAA;EACA,gBAAA;AArIN;AAwII;EACE,6DA9yBa;EA+yBb,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iDA1yBY;AAoqBlB;AAwIM;EACE,2BAAA;EACA,+CAAA;AAtIR;AAyIM;EACE,mBAAA;EACA,YAAA;AAvIR;;AA8IA;EACE;IAAK,2BAAA;EA1IL;EA2IA;IAAM,6BAAA;EAxIN;EAyIA;IAAO,2BAAA;EAtIP;AACF;AAwIA;EACE;IACE,qCAAA;EAtIF;EAwIA;IACE,2CAAA;EAtIF;EAwIA;IACE,0CAAA;EAtIF;AACF;AAyIA;EACE;IAAK,uBAAA;EAtIL;EAuIA;IAAO,yBAAA;EApIP;AACF;AAsIA;EACE;IACE,2BAAA;IACA,UAAA;EApIF;EAsIA;IACE,wBAAA;IACA,UAAA;EApIF;AACF;AAuIA;EACE;IAAO,UAAA;EApIP;EAqIA;IAAK,UAAA;EAlIL;AACF;AAoIA;EACE;IACE,2BAAA;IACA,UAAA;EAlIF;EAoIA;IACE,wBAAA;IACA,UAAA;EAlIF;AACF;AAqIA;EACE;IACE,4BAAA;IACA,UAAA;EAnIF;EAqIA;IACE,wBAAA;IACA,UAAA;EAnIF;AACF;AAsIA;EACE;IAAK,0CAAA;EAnIL;EAoIA;IAAO,yCAAA;EAjIP;AACF;AAmIA;EACE;IAAW,mBAAA;IAAqB,UAAA;EA/HhC;EAgIA;IAAM,sBAAA;IAAwB,YAAA;EA5H9B;AACF;AA8HA;EACE;IAAW,wBAAA;EA3HX;EA4HA;IAA0B,2BAAA;EAzH1B;EA0HA;IAAqB,0BAAA;EAvHrB;AACF;AA0HA;EAEI;IACE,gBAAA;EAzHJ;EA6HA;IACE,wBAAA;EA3HF;EA8HA;IACE,eAAA;EA5HF;AACF;AA+HA;EACE;IACE,oBAAA;EA7HF;EAgII;IACE,kBAAA;EA9HN;EAiII;IACE,WAAA;IACA,YAAA;EA/HN;EAoIA;IACE,eAAA;IACA,wBAAA;EAlIF;EAqIA;IACE,kBAAA;IACA,iBAAA;EAnIF;EAuIE;IACE,oBAAA;EArIJ;AACF;AA6IM;EACE,YAAA;AA3IR;AAiJI;EACE,0CAAA;AA/IN;;AAqJA;EACE,sDAAA;AAlJF;;AAqJA;EACE,uBAAA;AAlJF;;AAqJA;EACE,2BAAA;AAlJF","sourcesContent":["// Login.scss - Professional and Modern Login Page Styles\n\n// Variables\n$primary-gradient: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n$secondary-gradient: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n$success-gradient: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);\n$dark-gradient: linear-gradient(135deg, #30cfd0 0%, #330867 100%);\n\n$primary-color: #667eea;\n$secondary-color: #764ba2;\n$accent-color: #f093fb;\n$error-color: #f5576c;\n$success-color: #43e97b;\n\n$transition-base: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n$transition-smooth: all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n\n// Login Page Main Container\n.login-page {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  \n  &.animated-bg {\n    animation: gradientShift 15s ease infinite;\n    background-size: 400% 400%;\n  }\n\n  // Dark theme adjustments\n  [data-coreui-theme=\"dark\"] & {\n    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);\n  }\n}\n\n// Animated Background Shapes\n.animated-shapes {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n  overflow: hidden;\n  z-index: 1;\n\n  .shape {\n    position: absolute;\n    border-radius: 50%;\n    filter: blur(40px);\n    animation: float 20s infinite ease-in-out;\n    \n    &.shape-1 {\n      width: 500px;\n      height: 500px;\n      background: rgba(243, 147, 251, 0.3);\n      top: -250px;\n      right: -250px;\n      animation-delay: 0s;\n      animation-duration: 25s;\n    }\n    \n    &.shape-2 {\n      width: 400px;\n      height: 400px;\n      background: rgba(245, 87, 108, 0.3);\n      bottom: -200px;\n      left: -200px;\n      animation-delay: 5s;\n      animation-duration: 20s;\n    }\n    \n    &.shape-3 {\n      width: 300px;\n      height: 300px;\n      background: rgba(102, 126, 234, 0.3);\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      animation-delay: 10s;\n      animation-duration: 30s;\n    }\n  }\n\n  .floating-gradient {\n    position: absolute;\n    width: 150%;\n    height: 150%;\n    background: radial-gradient(circle at 50% 50%, \n      rgba(102, 126, 234, 0.1) 0%, \n      rgba(118, 75, 162, 0.1) 50%, \n      transparent 100%);\n    animation: rotate 60s linear infinite;\n    top: -25%;\n    left: -25%;\n  }\n}\n\n// Login Container\n.login-container {\n  width: 100%;\n  max-width: 1400px;\n  padding: 2rem;\n  \n  @media (max-width: 768px) {\n    padding: 1rem;\n  }\n}\n\n// Login Wrapper\n.login-wrapper {\n  position: relative;\n  z-index: 10;\n  animation: slideInUp 0.8s ease-out;\n  width: 100%;\n\n  .login-card {\n    background: rgba(255, 255, 255, 0.98);\n    backdrop-filter: blur(20px);\n    border-radius: 30px;\n    min-height: 650px;\n    height: auto;\n    transition: $transition-base;\n    \n    [data-coreui-theme=\"dark\"] & {\n      background: rgba(33, 37, 41, 0.98);\n    }\n\n    &:hover {\n      transform: translateY(-5px);\n      box-shadow: 0 30px 80px rgba(0, 0, 0, 0.25);\n    }\n\n    &.shake {\n      animation: shake 0.5s ease;\n    }\n  }\n}\n\n// Login Form Section\n.login-form-section {\n  position: relative;\n  display: flex;\n  align-items: center;\n  min-height: 650px;\n  \n  @media (max-width: 991px) {\n    min-height: 500px;\n  }\n\n  .login-form-body {\n    width: 100%;\n    padding: 3rem;\n    \n    @media (max-width: 991px) {\n      padding: 2.5rem;\n    }\n    \n    @media (max-width: 576px) {\n      padding: 2rem 1.5rem;\n    }\n  }\n\n  .login-content {\n    max-width: 420px;\n    margin: 0 auto;\n    width: 100%;\n  }\n\n  .login-header {\n    text-align: center;\n    animation: fadeIn 1s ease-out 0.3s both;\n\n    .logo-wrapper {\n      display: inline-block;\n      position: relative;\n      \n      .logo-icon {\n        width: 80px;\n        height: 80px;\n        background: $primary-gradient;\n        border-radius: 24px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        color: white;\n        box-shadow: 0 15px 35px rgba(102, 126, 234, 0.3);\n        position: relative;\n        overflow: hidden;\n        transition: $transition-base;\n        \n        &::before {\n          content: '';\n          position: absolute;\n          top: -50%;\n          left: -50%;\n          width: 200%;\n          height: 200%;\n          background: linear-gradient(45deg, \n            transparent, \n            rgba(255, 255, 255, 0.3), \n            transparent);\n          transform: rotate(45deg);\n          animation: shimmer 3s infinite;\n        }\n\n        &:hover {\n          transform: scale(1.1) rotate(5deg);\n          box-shadow: 0 20px 45px rgba(102, 126, 234, 0.4);\n        }\n        \n        @media (max-width: 576px) {\n          width: 70px;\n          height: 70px;\n        }\n      }\n    }\n\n    .login-title {\n      font-size: 2rem;\n      font-weight: 700;\n      color: #2c3e50;\n      margin-bottom: 0.5rem;\n      background: $primary-gradient;\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n      background-clip: text;\n      \n      [data-coreui-theme=\"dark\"] & {\n        background: linear-gradient(135deg, #8da3f0 0%, #b88fe8 100%);\n        -webkit-background-clip: text;\n        -webkit-text-fill-color: transparent;\n        background-clip: text;\n      }\n      \n      @media (max-width: 576px) {\n        font-size: 1.75rem;\n      }\n    }\n\n    .login-subtitle {\n      font-size: 1rem;\n      color: #6c757d;\n      \n      [data-coreui-theme=\"dark\"] & {\n        color: #adb5bd;\n      }\n    }\n  }\n\n  .login-form {\n    animation: fadeIn 1s ease-out 0.5s both;\n  }\n}\n\n// Modern Input Groups\n.form-floating-group {\n  position: relative;\n  margin-bottom: 1.5rem;\n  transition: $transition-base;\n\n  &.focused {\n    transform: translateY(-2px);\n  }\n\n  .modern-input-group {\n    position: relative;\n    background: #f8f9fa;\n    border-radius: 15px;\n    overflow: hidden;\n    transition: $transition-base;\n    border: 2px solid transparent;\n    \n    [data-coreui-theme=\"dark\"] & {\n      background: rgba(255, 255, 255, 0.05);\n    }\n\n    &:focus-within {\n      background: white;\n      border-color: $primary-color;\n      box-shadow: 0 10px 30px rgba(102, 126, 234, 0.1);\n      \n      [data-coreui-theme=\"dark\"] & {\n        background: rgba(255, 255, 255, 0.08);\n      }\n\n      .input-icon {\n        color: $primary-color;\n        transform: scale(1.1);\n      }\n\n      .input-focus-border {\n        transform: scaleX(1);\n      }\n    }\n\n    .input-icon {\n      background: transparent;\n      border: none;\n      color: #6c757d;\n      padding: 0 1.25rem;\n      transition: $transition-base;\n      \n      [data-coreui-theme=\"dark\"] & {\n        color: #adb5bd;\n      }\n    }\n\n    .modern-input {\n      border: none;\n      background: transparent;\n      padding: 1rem 0;\n      font-size: 1rem;\n      transition: $transition-base;\n      \n      &:focus {\n        box-shadow: none;\n        outline: none;\n      }\n\n      &::placeholder {\n        color: #adb5bd;\n        transition: $transition-base;\n      }\n\n      &:focus::placeholder {\n        transform: translateX(5px);\n        opacity: 0.7;\n      }\n\n      &.is-invalid {\n        background: rgba(245, 87, 108, 0.05);\n      }\n    }\n\n    .password-toggle {\n      background: transparent;\n      border: none;\n      cursor: pointer;\n      color: #6c757d;\n      padding: 0 1.25rem;\n      transition: $transition-base;\n      \n      [data-coreui-theme=\"dark\"] & {\n        color: #adb5bd;\n      }\n\n      &:hover {\n        color: $primary-color;\n        background: rgba(102, 126, 234, 0.05);\n      }\n    }\n\n    .input-focus-border {\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      height: 3px;\n      background: $primary-gradient;\n      transform: scaleX(0);\n      transition: transform 0.3s ease;\n    }\n  }\n\n  .animated-error {\n    animation: slideInLeft 0.3s ease;\n    color: $error-color;\n    display: flex;\n    align-items: center;\n    font-size: 0.875rem;\n    font-weight: 500;\n  }\n}\n\n// Modern Checkbox\n.modern-checkbox {\n  .form-check-input {\n    width: 1.25rem;\n    height: 1.25rem;\n    border: 2px solid #dee2e6;\n    transition: $transition-base;\n    \n    &:checked {\n      background-color: $primary-color;\n      border-color: $primary-color;\n      box-shadow: 0 3px 10px rgba(102, 126, 234, 0.3);\n    }\n\n    &:focus {\n      box-shadow: 0 0 0 0.25rem rgba(102, 126, 234, 0.25);\n    }\n  }\n\n  .form-check-label {\n    margin-left: 0.5rem;\n    color: #6c757d;\n    font-size: 0.9rem;\n    cursor: pointer;\n    transition: $transition-base;\n    \n    [data-coreui-theme=\"dark\"] & {\n      color: #adb5bd;\n    }\n\n    &:hover {\n      color: $primary-color;\n    }\n  }\n}\n\n// Forgot Password Link\n.forgot-password-link {\n  color: $primary-color;\n  text-decoration: none;\n  font-size: 0.9rem;\n  font-weight: 500;\n  transition: $transition-base;\n  position: relative;\n\n  &::after {\n    content: '';\n    position: absolute;\n    bottom: -2px;\n    left: 0;\n    width: 0;\n    height: 2px;\n    background: $primary-gradient;\n    transition: width 0.3s ease;\n  }\n\n  &:hover {\n    color: $secondary-color;\n    \n    &::after {\n      width: 100%;\n    }\n  }\n}\n\n// Login Button\n.login-button {\n  background: $primary-gradient;\n  border: none;\n  border-radius: 15px;\n  padding: 1rem 2rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: white;\n  position: relative;\n  overflow: hidden;\n  transition: $transition-smooth;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, \n      transparent, \n      rgba(255, 255, 255, 0.3), \n      transparent);\n    transition: left 0.5s ease;\n  }\n\n  &:hover:not(:disabled) {\n    transform: translateY(-3px);\n    box-shadow: 0 15px 40px rgba(102, 126, 234, 0.4);\n    \n    &::before {\n      left: 100%;\n    }\n  }\n\n  &:active:not(:disabled) {\n    transform: translateY(-1px);\n  }\n\n  &:disabled {\n    background: #6c757d;\n    opacity: 0.7;\n    cursor: not-allowed;\n  }\n\n  .spinner-border {\n    width: 1rem;\n    height: 1rem;\n    border-width: 2px;\n  }\n}\n\n// Divider\n.divider-container {\n  display: flex;\n  align-items: center;\n  margin: 2rem 0;\n\n  .divider-line {\n    flex: 1;\n    height: 1px;\n    background: linear-gradient(90deg, transparent, #dee2e6, transparent);\n  }\n\n  .divider-text {\n    padding: 0 1rem;\n    color: #6c757d;\n    font-size: 0.85rem;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    font-weight: 500;\n    \n    [data-coreui-theme=\"dark\"] & {\n      color: #adb5bd;\n    }\n  }\n}\n\n// Social Login Buttons\n.social-login-btn {\n  border: 2px solid #e9ecef;\n  border-radius: 12px;\n  padding: 0.75rem;\n  background: white;\n  transition: $transition-base;\n  font-weight: 600;\n  font-size: 0.9rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  \n  [data-coreui-theme=\"dark\"] & {\n    background: rgba(255, 255, 255, 0.05);\n    border-color: rgba(255, 255, 255, 0.1);\n    color: #e9ecef;\n  }\n\n  .social-icon {\n    width: 20px;\n    height: 20px;\n    margin-right: 0.5rem;\n  }\n\n  &.google-btn:hover {\n    border-color: #4285F4;\n    background: rgba(66, 133, 244, 0.05);\n    transform: translateY(-2px);\n    box-shadow: 0 5px 15px rgba(66, 133, 244, 0.2);\n  }\n\n  &.microsoft-btn:hover {\n    border-color: #00A4EF;\n    background: rgba(0, 164, 239, 0.05);\n    transform: translateY(-2px);\n    box-shadow: 0 5px 15px rgba(0, 164, 239, 0.2);\n  }\n}\n\n// Welcome Section\n.welcome-section {\n  position: relative;\n  background: $primary-gradient;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem 2rem;\n  overflow: hidden;\n  min-height: 650px;\n  \n  @media (max-width: 1200px) {\n    padding: 2.5rem 1.5rem;\n  }\n  \n  @media (max-width: 991px) {\n    display: none !important;\n  }\n\n  .welcome-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: radial-gradient(circle at 30% 80%, \n      rgba(243, 147, 251, 0.3) 0%, \n      transparent 50%),\n      radial-gradient(circle at 80% 20%, \n      rgba(245, 87, 108, 0.3) 0%, \n      transparent 50%);\n    animation: pulse 4s ease-in-out infinite;\n  }\n\n  .welcome-content {\n    position:relative;\n    height: 100%;\n    z-index: 2;\n    color: white;\n    text-align: center;\n  }\n\n  .welcome-text {\n    animation: fadeInUp 1s ease-out 0.7s both;\n  }\n\n  .welcome-title {\n    font-size: 2.5rem;\n    font-weight: 700;\n    margin-bottom: 1.5rem;\n    text-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);\n    line-height: 1.3;\n  }\n\n  .welcome-description {\n    font-size: 1.1rem;\n    margin-bottom: 3rem;\n    opacity: 0.95;\n    line-height: 1.6;\n  }\n\n  .feature-list {\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    max-width: 300px;\n    margin: 0 auto;\n  }\n\n  .feature-item {\n    display: flex;\n    align-items: center;\n    margin-bottom: 1.5rem;\n    padding: 1rem;\n    background: rgba(255, 255, 255, 0.1);\n    backdrop-filter: blur(10px);\n    border-radius: 12px;\n    width: 100%;\n    transition: $transition-base;\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.2);\n      transform: translateX(10px);\n    }\n\n    .feature-icon {\n      color: #43e97b;\n      margin-right: 1rem;\n      font-size: 1.25rem;\n      filter: drop-shadow(0 2px 5px rgba(67, 233, 123, 0.5));\n    }\n\n    span {\n      font-size: 1rem;\n      font-weight: 500;\n    }\n  }\n\n  .decoration-circles {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    pointer-events: none;\n\n    .circle {\n      position: absolute;\n      border-radius: 50%;\n      border: 2px solid rgba(255, 255, 255, 0.2);\n      animation: float 15s infinite ease-in-out;\n\n      &.circle-1 {\n        width: 100px;\n        height: 100px;\n        top: 10%;\n        right: 10%;\n        animation-delay: 0s;\n      }\n\n      &.circle-2 {\n        width: 150px;\n        height: 150px;\n        bottom: 20%;\n        left: 5%;\n        animation-delay: 5s;\n      }\n\n      &.circle-3 {\n        width: 80px;\n        height: 80px;\n        top: 50%;\n        right: 30%;\n        animation-delay: 10s;\n      }\n    }\n  }\n}\n\n// Two Factor Modal\n.two-factor-modal {\n  .modal-content {\n    border: none;\n    border-radius: 25px;\n    overflow: hidden;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\n    \n    [data-coreui-theme=\"dark\"] & {\n      background: rgba(33, 37, 41, 0.98);\n    }\n  }\n\n  .two-factor-header {\n    background: $primary-gradient;\n    color: white;\n    padding: 2rem;\n    border: none;\n\n    .modal-title {\n      font-weight: 600;\n      display: flex;\n      align-items: center;\n    }\n\n    .btn-close {\n      filter: brightness(0) invert(1);\n      opacity: 0.8;\n      \n      &:hover {\n        opacity: 1;\n      }\n    }\n  }\n\n  .two-factor-body {\n    padding: 2.5rem 2rem;\n\n    .security-icon-wrapper {\n      width: 100px;\n      height: 100px;\n      margin: 0 auto;\n      background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      box-shadow: 0 15px 35px rgba(67, 233, 123, 0.3);\n      animation: pulse 2s ease-in-out infinite;\n\n      .security-icon {\n        color: white;\n        filter: drop-shadow(0 3px 8px rgba(0, 0, 0, 0.2));\n      }\n    }\n\n    .security-message {\n      color: #6c757d;\n      font-size: 1rem;\n      line-height: 1.5;\n      \n      [data-coreui-theme=\"dark\"] & {\n        color: #adb5bd;\n      }\n    }\n\n    .two-factor-input {\n      border: 2px solid #e9ecef;\n      border-radius: 15px;\n      padding: 1rem;\n      font-size: 1.5rem;\n      text-align: center;\n      letter-spacing: 5px;\n      font-weight: 600;\n      transition: $transition-base;\n      \n      [data-coreui-theme=\"dark\"] & {\n        background: rgba(255, 255, 255, 0.05);\n        border-color: rgba(255, 255, 255, 0.1);\n        color: #e9ecef;\n      }\n\n      &:focus {\n        border-color: $primary-color;\n        box-shadow: 0 0 0 0.25rem rgba(102, 126, 234, 0.25);\n      }\n    }\n\n    .resend-link {\n      color: $primary-color;\n      text-decoration: none;\n      font-weight: 600;\n      transition: $transition-base;\n\n      &:hover {\n        color: $secondary-color;\n        text-decoration: underline;\n      }\n    }\n  }\n\n  .two-factor-footer {\n    padding: 1.5rem 2rem 2rem;\n    border: none;\n\n    .cancel-btn {\n      border-radius: 12px;\n      padding: 0.75rem 1.5rem;\n      font-weight: 600;\n    }\n\n    .verify-btn {\n      background: $success-gradient;\n      border: none;\n      border-radius: 12px;\n      padding: 0.75rem 1.5rem;\n      font-weight: 600;\n      transition: $transition-base;\n\n      &:hover:not(:disabled) {\n        transform: translateY(-2px);\n        box-shadow: 0 10px 25px rgba(67, 233, 123, 0.3);\n      }\n\n      &:disabled {\n        background: #6c757d;\n        opacity: 0.7;\n      }\n    }\n  }\n}\n\n// Animations\n@keyframes gradientShift {\n  0% { background-position: 0% 50%; }\n  50% { background-position: 100% 50%; }\n  100% { background-position: 0% 50%; }\n}\n\n@keyframes float {\n  0%, 100% {\n    transform: translateY(0) rotate(0deg);\n  }\n  33% {\n    transform: translateY(-30px) rotate(120deg);\n  }\n  66% {\n    transform: translateY(20px) rotate(240deg);\n  }\n}\n\n@keyframes rotate {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n@keyframes slideInUp {\n  from {\n    transform: translateY(50px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes fadeInUp {\n  from {\n    transform: translateY(30px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n@keyframes slideInLeft {\n  from {\n    transform: translateX(-20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n@keyframes shimmer {\n  0% { transform: translateX(-100%) rotate(45deg); }\n  100% { transform: translateX(100%) rotate(45deg); }\n}\n\n@keyframes pulse {\n  0%, 100% { transform: scale(1); opacity: 1; }\n  50% { transform: scale(1.05); opacity: 0.8; }\n}\n\n@keyframes shake {\n  0%, 100% { transform: translateX(0); }\n  10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }\n  20%, 40%, 60%, 80% { transform: translateX(5px); }\n}\n\n// Responsive Design\n@media (max-width: 991px) {\n  .login-wrapper {\n    .login-card {\n      min-height: auto;\n    }\n  }\n\n  .welcome-section {\n    display: none !important;\n  }\n\n  .login-form-section {\n    padding: 2.5rem;\n  }\n}\n\n@media (max-width: 576px) {\n  .login-form-section {\n    padding: 2rem 1.5rem;\n\n    .login-header {\n      .login-title {\n        font-size: 1.75rem;\n      }\n\n      .logo-wrapper .logo-icon {\n        width: 70px;\n        height: 70px;\n      }\n    }\n  }\n\n  .login-button {\n    font-size: 1rem;\n    padding: 0.875rem 1.5rem;\n  }\n\n  .social-login-btn {\n    font-size: 0.85rem;\n    padding: 0.625rem;\n  }\n\n  .two-factor-modal {\n    .two-factor-body {\n      padding: 2rem 1.5rem;\n    }\n  }\n}\n\n// Dark Theme Enhancements\n[data-coreui-theme=\"dark\"] {\n  .login-page {\n    .animated-shapes {\n      .shape {\n        opacity: 0.5;\n      }\n    }\n  }\n\n  .login-wrapper {\n    .login-card {\n      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n    }\n  }\n}\n\n// Utility Classes\n.shadow-lg {\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;\n}\n\n.border-0 {\n  border: none !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
